<template>
    <div class="chat-main-wrapper-div" :class="getFilesCountClass" ref="editorMainWrapperDiv">
      <files-browser class="bins-catalog-browser-from-richtexteditor" style="z-index:9999999 !important;" v-if="browserType == 'fusion'" :enableAssetMultiSelect="true" :workspaceList="getWorkspacesList" @close="closeModal" @handleFilesBrowse="handleFilesBrowse"></files-browser>
      <div class="common-input-field main-chat-area-zoom-screen" :ref="replyContext?'inputReplyField':'mainReplyField'" :class='!replyContext?"input-field-height-check":"reply-threadinput-field-height-check"' style="margin-top:7px;">  
        <attach-file v-if="openAttachments" :disableAnnotation="true" class="attachment-list-chat" v-bind="attachmentData" uniqueId='attachMediaToMessage' :emptyfiles="emptyfiles"  :alreadyAttachedFiles="attachedFiles" @openPipOfAttachment="openPipOfAttachment" @attachedFilesList="attachedFilesList" :customizeStyles="customizeStyles" style="height: calc(100% - 120px);
    overflow: auto;max-height: 200px;"></attach-file>
       <div v-if="showMentions" :style="isEditorIsInFullScreen && mentionDropdownPosition" ref="scrollContainer" class='mentions-wrapper'>
                <div ref="test" v-for="(uItem, index) in filteredDropdown" :key="uItem._id" v-on:click="selectUserToBeMentioned(uItem)" :class="{ focusElement: index === focus }" class="mentions-option">
                    <div v-if="Object.keys(uItem).includes('profile_image') && !['undefined',null].includes(uItem.profile_image) && uItem.profile_image" class='user-name-or-image' style="margin-inline-end: 9px;">
                        <img :src="getProxyConvertedURL(uItem.profile_image)" @error="replaceWithUserIcon($event)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                    </div>
                    <div v-else class="user-name-or-image user-name" :style="style(uItem.username)">{{ uItem.username.split("")[0] }}
                    </div> 
                    <div style="display: flex;align-items: center;">{{uItem.username}}</div>
                </div>
        </div>
           <div class="suneditor-wrapper-div" @click.stop>
                <textarea ref="richTextEditorRef"></textarea>
            </div>
    
            <div style="float:inline-start;display:flex" class="rich-texteditor-main-tools-wrapper">
                <div v-if="isFileAttachmentReqrd && !editMessageEnabled && (isEnabled('Upload') || getLoggedInUserInfo().user_type != 'Client')" class="nav-item dropdown show rich-text-component-file-attachment" style="inset-inline-start:2%">
                  <a class="nav-item nav-link dropdown-toggle mr-md-2 icon-background-on-hover" href="#" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" :style="getButtonStyles">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" fill="#eee" class="bi bi-paperclip" viewBox="0 0 16 16">
                        <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
                        <title>{{$t('Attach files')}}</title>
                    </svg>
                  </a>
                  <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                    <a v-if="((isEnabled('catalogs-workspace') || isEnabled('bins-workspace')) && getLoggedInUserInfo().user_type != 'Client')" class="dropdown-item p-2 d-flex" v-on:click="openFileBrowseOnClick('fusion')">
                        <div style="height:20px;width:20px">
                            <img :src="fusionLogo" style="width:100%;height:100%;position: relative;inset-inline-end :4px;">
                        </div>
                      <span>{{$t('from fusion')}}</span>
                    </a>
                    <a v-if="isEnabled('Upload')" class="dropdown-item p-2" style="position:relative;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" style="position: relative;inset-inline-end :4px;" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                        <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                       </svg>
                      <span>{{$t('from your computer')}}</span>
                      <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                            <input 
                                style="height:100%;width:100%"
                                type="file"
                                id="file"
                                ref="uploadFile"
                                multiple
                                v-on:click="resetImageUploader()"
                                v-on:change="getSelectedFileDetailsFromBrowse($event)"
                                />
                        </div></a>
                  </div>
                </div>

                <div v-if="isEmojiReqrd" style="position:relative;" v-click-outside='hideEmojis' class='icon-background-on-hover emojis-wrapper' :style="getButtonStyles">
                    <div @click="showEmojis = !showEmojis">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-emoji-smile-fill" viewBox="0 0 16 16">
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"/>
                        </svg>
                    </div>
                    <div v-if="showEmojis" class='emojies-display'>
                        <span @click="sendThumbsUpEmoji('\u{1F60A}')">&#128522;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F602}')">&#128514;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F607}')">&#128519;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F60D}')">&#128525;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F641}')">&#128577;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F44D}')">&#128077;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F44F}')">&#128079;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F64F}')">&#128591;</span>
                        <span @click="sendThumbsUpEmoji('\u{2705}')">&#9989;</span>
                        <span @click="sendThumbsUpEmoji('\u{274C}')">&#10060;</span>
                    </div>
                </div>
                <template v-if="isTaskTicketsBrowseReqrd && (isEnabled('Ticket') || isEnabled('Projects') || isEnabled('Confluence'))">
                    <div v-click-outside="hideTaskTicketsMenu" id="DAM-chat-insert_pam">
                        <div @click.prevent.stop="isTasksAndTicketsDropdownShown = !isTasksAndTicketsDropdownShown" class="mr-md-2 icon-background-on-hover task-tickets-icon-click">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" fill="#eee" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                            </svg>
                        </div>
                        <div v-if="isTasksAndTicketsDropdownShown" class="task-tickets-browse dropdown-menu-md-right p-0">
                            
                          <template v-for="browseItem in getLinksBrowseListPlugins">
                                <a v-if="isBrowseEnabled(browseItem.privilege)" :key="browseItem.id || browseItem.privilege" class="dropdown-item p-2 d-flex" v-on:click="openFileBrowseOnClick(browseItem.openBrowseName)" style="padding: 0.4rem 0.5rem !important;">
                                    <div style="height:20px;width:20px">
                                        <div v-if="browseItem.svgIcon" v-html="browseItem.svgIcon"></div>
                                    </div>
                                    <span>{{$t(browseItem.name)}}</span>
                                </a>
                           </template> 
                        </div>
                    </div>
                </template>

               <div v-if="isToggleToolbarBtnReqrd" class="nav-item dropdown show toggle-editor-icon" style="inset-inline-start:2%">
                  <a :title="$t('Enable/Disable toolbar')" class="nav-item nav-link dropdown-toggle mr-md-2 icon-background-on-hover" @click.prevent.stop="toggleEditorToolbar()" href="#" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" :style="getButtonStyles">
                      <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" :style="isEditorToolbarOpen ? 'fill: #00bdbd;':'fill: #ddd'"><path d="M80 0v-160h800V0H80Zm140-280 210-560h100l210 560h-96l-50-144H368l-52 144h-96Zm176-224h168l-82-232h-4l-82 232Z"/></svg>
                  </a>
                </div>

                <slot name="toggleEditorToolbar"></slot>  <!-- Slot from rich texteditor -->

            </div>
        
            <div class="rich-text-editor-save-and-cancel" style="float:inline-end" v-if="isSendAndUpdateBtnReqrd">  
                <button :title="$t('Send message')" v-if="!editMessageEnabled" class="btn btn-primary button-styles" @click="sendMessageOrReply()" :class="replyContext == true?'replay-comment-btn':'main-comment-btn'" style="background:#5a5a5a;border-color:#5a5a5a">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#eee" class="bi bi-send-fill" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89.471-1.178-1.178.471L5.93 9.363l.338.215a.5.5 0 0 1 .154.154l.215.338 7.494-7.494Z"/>
                    </svg>
                </button>
                <template v-if="editMessageEnabled">
                    <button  @click="cancelUpdateMessage()" class="btn btn-outline-secondary"  :class="editMessageEnabled?'edit-mode-action-button':''" style="line-height: initial;margin-inline-end:10px;">
                    {{$t('Cancel')}}
                    </button>
                    <button  @click="updateMessage()" class="btn btn-outline-primary" :class="editMessageEnabled?'edit-mode-action-button':''" style="line-height: initial;">
                    {{$t('Save')}}
                    </button>
                </template>
            </div> 
      </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import AttachFile from "../Attachments.vue";
import Utils from "../../../components.utils.js";
import fileBrowseModel from "../../files/filesBrowse.vue";
import Constants from "../../../components.constants.js";
import suneditor from 'suneditor';
import en from 'suneditor/src/lang/en';
import plugins from 'suneditor/src/plugins';

export default {
   name:'RichTextEditor',
   props:["usersList","emptyAttachmentsData","closeMentions","editMessageEnabled","editMessage","commentDataToEdit","clearMainInputAreaText","channelData","usersFilterFunction","isFileAttachmentRequired","isEmojiRequired","isTaskTicketsBrowseRequired","isSendAndUpdateBtnRequired","richTextParentScrollContainer","isToggleToolbarBtnRequired","heightSettings","buttonStyles","browseWorkspaceList","isNewPluginRegistrationApproach"],
   data(){
       return {
           chatBrowseWorkspaceList:[Constants.WORKSPACE_CATALOG,Constants.WORKSPACE_BINS],
           fusionLogo:Utils.getLogo(),
           commentText:"",
           selectedFilesFromAttachments:null,
           attachedFilesArr:[],
           attachmentUniqueId:null,
           emptyfiles:false,
           customizeStyles:{
               "background": "#22272b",
               "border": "1px solid  #434343"
           },
           openAttachments:false,
           showMentions:false,
           keypressedForMention:'',
           focus: null,
           positionOfDropdown:{"top":0,"left":0},
           stop:false,
           showEmojis:false,
           cursorPosition:0,
           openFileBrowse:false,
           attachedFiles:[],
           browserType:"",
           isEditorToolbarOpen: false,
           sunEditorInstance:{},
           isEditorIsInFullScreen: false,
           mentionDropdownPosition: { top: 0, left :0 },
           isTasksAndTicketsDropdownShown:false,
           buttonsToHide:['undo', 'redo', 'font', 'fontSize', 'formatBlock', 'fontColor', 'hiliteColor'],
           isFileAttachmentReqrd: true,
           isEmojiReqrd:true,
           isTaskTicketsBrowseReqrd: true,
           isSendAndUpdateBtnReqrd:true,
           replyContext:false,
           isToggleToolbarBtnReqrd: true,
           isEnterSendAllowed:false,
           tasksTicketsBrowseList : [Constants.WORKSPACE_TICKETS,Constants.WORKSPACE_TASKS,Constants.WORKSPACE_ISSUES],
       };
   },
   mounted(){
    //  console.log("suneditorCSS suneditorCSS",suneditorCSS);
     let maxHeight = '180';
     let minHeight = '102';
     if(this.heightSettings){
         if('maxHeight' in this.heightSettings && this.heightSettings.maxHeight){
            maxHeight = this.heightSettings.maxHeight;
         }
         if('minHeight' in this.heightSettings && this.heightSettings.minHeight){
            minHeight = this.heightSettings.minHeight;
         }
     }
     this.$nextTick(()=>{
         this.sunEditorInstance = suneditor.create(this.$refs['richTextEditorRef'], {
            hideToolbar: true,   // hides toolbar by default
            buttonList: [
            // group 1
            ['undo', 'redo'],
            ['font', 'fontSize', 'formatBlock'],
            ['fontColor','hiliteColor'],
            ['bold', 'underline', 'italic', 'strike'],
            // group 3
            ['outdent', 'indent'],
            // group 4
            ['align', 'list'],
            // group 5
             ['removeFormat'],
             ['fullScreen'],
            ],
            lang:en, //this.getLangaugeMapperForEditor(this.$t),  // ✅ custom mapper,
            plugins: [plugins.font,plugins.fontColor, plugins.align,plugins.list,plugins.table,plugins.horizontalRule,plugins.hiliteColor , plugins.fontSize ,
               plugins.formatBlock, plugins.paragraphStyle
            ],
            height: 'auto',        // let height expand automatically
            maxHeight: maxHeight,    // optional (limit if you don’t want it too tall)
            minHeight: minHeight,
            autoResize: true   ,
            defaultStyle: 'font-family: "Roboto"; font-size: 14px;',
            placeholder:`${this.$t('Add Message')}...`,
            font:["Roboto","Arial","Comic Sans MS","Courier New","Impact","Georgia","tahoma","Trebuchet MS","Verdana"],
            paragraphStyles: true,
            addTagsWhitelist: 'p|br|div|h1|h2|h3|h4|h5|h6|ol|ul|li|table|tr|td|thead|tbody|th|blockquote|hr|section|figure|figcaption|span|strong|em|u|s|font|a',
            pasteTagsWhitelist: 'p|br|div|h1|h2|h3|h4|h5|h6|ol|ul|li|table|tr|td|thead|tbody|th|blockquote|hr|section|figure|figcaption|span|strong|em|u|s|font|a',
            attributesWhitelist:{
               all: 'style',
               input: 'checked',
               font: 'color face size',
            },
         })  
        //this.sunEditorInstance.onKeyDown = (e) => { console.log('onKeyDown', e);  if(e.key.length === 1){ this.checkForMentions(e) }}
        this.sunEditorInstance.onKeyUp = (e) => {  if(e.key === "Backspace" || e.key === "Delete") { this.detectBackspace(e); }}
       //this.sunEditorInstance.onFocus = (e) => { this.changeBckClrOfSendBtn(e); }
       //this.sunEditorInstance.onBlur = (e) => { this.changeBckClrOfSendBtn(e); }
        this.sunEditorInstance.onPaste = (e, cleanData, maxCharCount) =>{
            console.log("Copy paste.........",e, cleanData, maxCharCount);
            const htmlData = e.clipboardData.getData('text/html');
            
            // 💡 CRITICAL: Check for the signature of the problematic pasted HTML 
            // (white-space: pre-wrap often signals unstructured content).
            if (htmlData && htmlData.includes('white-space: pre-wrap')) { 
                
                const textData = e.clipboardData.getData('text/plain');
                
                // 1. Normalize and Split into logical "paragraphs" (separated by 2+ newlines)
                // We use a regex to split the text based on where the user intended paragraph breaks.
                const paragraphs = textData
                    .replace(/(\r\n|\r)/g, '\n')  // Normalize all newlines to \n
                    .split(/\n{2,}/g)            // Split by two or more newlines
                    .filter(p => p.trim().length > 0); // Remove empty resulting strings
                
                let formattedHtml = '';

                // 2. Format and wrap each paragraph
                paragraphs.forEach(pText => {
                    // a. Replace single remaining newlines (within a paragraph) with <br> tags.
                    // This preserves list structure or single line breaks.
                    let pContent = pText.replace(/\n/g, '<br>');
                    
                    // b. Wrap the content in <p> tags, which SunEditor recognizes as blocks.
                    formattedHtml += `<p>${pContent.trim()}</p>`;
                });

                // 3. Inject the clean, structured HTML into the editor.
                // We use the last two optional parameters (true, false) to tell SunEditor 
                // to accept the input without aggressively re-processing it as plain text.
                this.setContents(formattedHtml, true, false);
                e.preventDefault(); 
                
                return false; // Stop default paste processing
            }

            // If the content is rich HTML, let SunEditor handle it normally
            return true;
        }
        this.sunEditorInstance.toggleFullScreen = (isFullScreen,core) => { 
             this.isEditorIsInFullScreen = isFullScreen;
             try{
                const toolbar = core.context.element.toolbar;
                this.buttonsToHide.forEach(cmd => {
                    const btn = toolbar.querySelector(`[data-command="${cmd}"]`).closest('div.se-btn-module');
                    if (btn) btn.style.display = isFullScreen ? '' : 'none';
                });
             }catch(e){console.log(e)}
             if(isFullScreen){
                core.context.element.wysiwyg.classList.add("editor-in-full-screen-mode");
                core.context.element.topArea.classList.add('top-editor-in-full-screen-mode');
                this.$refs.editorMainWrapperDiv.classList.add('main-editor-in-full-screen-mode');
                //fullScreenWindow.classList.add('chat-in-fullscreen');
                core.focus();
             }else{
                 core.context.element.wysiwyg.classList.remove("editor-in-full-screen-mode");
                 core.context.element.topArea.classList.remove('top-editor-in-full-screen-mode');
                 this.$refs.editorMainWrapperDiv.classList.remove('main-editor-in-full-screen-mode');
                // fullScreenWindow.classList.remove('chat-in-fullscreen');
             }
             if(!isFullScreen){ 
                this.scrollSunEditorTotheCenter(core);
                return;
             }
             const selection = core.getSelection();
             console.log("selectionselectionselectionselection",selection);
             if (!selection || selection.rangeCount === 0 || !this.sunEditorInstance.getText()) {
                 this.placeCaretAtTheStartOfSunEditor();
                return;
             }
            this.scrollSunEditorTotheCenter(core);
        }   
        this.sunEditorInstance.onload = (core, reload) =>{
            console.log("core, reload core, reload",core, reload);
            core.history.reset(0);
            this.scrollSunEditorTotheCenter(core);
            setTimeout(()=>{
                const toolbar = core.context.element.toolbar;
                this.buttonsToHide.forEach(cmd => {
                const btn = toolbar.querySelector(`[data-command="${cmd}"]`).closest('div.se-btn-module');
                    if (btn) btn.style.display = 'none';
                });
            },900);

           const originalRemoveFormat = core.removeFormat;
           core.removeFormat = function () {
            // Run original removeFormat behavior first
        
            if (typeof originalRemoveFormat === 'function') {
                originalRemoveFormat.apply(this, arguments);
            }
            const selection = window.getSelection();
            if (!selection || selection.rangeCount === 0) return;

            const range = selection.getRangeAt(0);
            const fragment = range.cloneContents();

            // Get all elements inside the selection
            const tempDiv = document.createElement('div');
            tempDiv.appendChild(fragment.cloneNode(true));
            const selectedElements = tempDiv.querySelectorAll('*');
            selectedElements.forEach(el => {
                 /*
                    if (el.tagName === 'UL' || el.tagName === 'LI') {
                        el.removeAttribute('color');
                        el.removeAttribute('background');
                        el.removeAttribute('backgroundColor');
                        el.removeAttribute('background-colour');
                        if (el.style) {
                            el.style.background = '';
                            el.style.backgroundColor = '';
                            el.style.color = '';
                        }
                        return;
                    }
                    */
                   if (el.tagName === 'UL' || el.tagName === 'OL') {
                        const parent = el.parentNode;
                        while (el.firstChild) parent.insertBefore(el.firstChild, el);
                        parent.removeChild(el);
                    }

                    if (el.tagName === 'LI') {
                        const parent = el.parentNode;
                        const p = document.createElement('p');
                        p.textContent = el.textContent;
                        parent.insertBefore(p, el);
                        parent.removeChild(el);
                    }
                    // Remove unwanted attributes
                    el.removeAttribute('style');
                    el.removeAttribute('color');
                    el.removeAttribute('face');
                    el.removeAttribute('size');
                    el.removeAttribute('background');
                    el.removeAttribute('backgroundColor');
                    el.removeAttribute('background-colour');

                    if (el.style) {
                        el.style.background = '';
                        el.style.backgroundColor = '';
                        el.style.color = '';
                        el.style.fontWeight = '';
                        el.style.textDecoration = '';
                        el.style.fontFamily = '';
                        el.style.fontSize = '';
                        el.style.fontStyle = '';
                    }

                    // Unwrap unwanted formatting tags
                    if (['B', 'I', 'U', 'FONT', 'SPAN', 'STRONG', 'EM'].includes(el.tagName)) {
                    const parent = el.parentNode;
                    while (el.firstChild) parent.insertBefore(el.firstChild, el);
                       parent.removeChild(el);
                    }
                });

                // Replace selection with cleaned content
                const cleanedFragment = document.createDocumentFragment();
                cleanedFragment.append(...tempDiv.childNodes);
                range.deleteContents();
                range.insertNode(cleanedFragment);

                // Restore cursor position after cleanup
                selection.removeAllRanges();
                selection.addRange(range);
            };

            const originalRemoveBackgroundColor = core.plugins.hiliteColor.remove;
            core.plugins.hiliteColor.remove = function () {
                
                if(typeof originalRemoveBackgroundColor === 'function') {
                     originalRemoveBackgroundColor.apply(this, arguments);
                 }

            const selection = window.getSelection();
            if (!selection || selection.rangeCount === 0) return;
            const range = selection.getRangeAt(0);
            const fragment = range.cloneContents();
            // Get all elements inside the selection
            const tempDiv = document.createElement('div');
            tempDiv.appendChild(fragment.cloneNode(true));
            const selectedElements = tempDiv.querySelectorAll('*');
            selectedElements.forEach(el => {
                    // ✅ Keep <ul> and <li> as-is
                    if (el.tagName === 'UL' || el.tagName === 'LI') {
                        el.removeAttribute('background');
                        el.removeAttribute('backgroundColor');
                        el.removeAttribute('background-colour');
                        if (el.style) {
                            el.style.background = '';
                            el.style.backgroundColor = '';
                        }
                        return;
                    }
                    // Remove unwanted attributes
                    el.removeAttribute('background');
                    el.removeAttribute('backgroundColor');
                    el.removeAttribute('background-colour');

                    if (el.style) {
                        el.style.background = '';
                        el.style.backgroundColor = '';
                    }
                });

                // Replace selection with cleaned content
                const cleanedFragment = document.createDocumentFragment();
                cleanedFragment.append(...tempDiv.childNodes);
                range.deleteContents();
                range.insertNode(cleanedFragment);

                // Restore cursor position after cleanup
                selection.removeAllRanges();
                selection.addRange(range);
            };

            const originalFontColorRemove = core.plugins.fontColor.remove;
            core.plugins.fontColor.remove = function () {
                 if(typeof originalFontColorRemove === 'function') {
                     originalFontColorRemove.apply(this, arguments);
                 }

            const selection = window.getSelection();
            if (!selection || selection.rangeCount === 0) return;
            const range = selection.getRangeAt(0);
            const fragment = range.cloneContents();
            // Get all elements inside the selection
            const tempDiv = document.createElement('div');
            tempDiv.appendChild(fragment.cloneNode(true));
            const selectedElements = tempDiv.querySelectorAll('*');
            selectedElements.forEach(el => {
                    // ✅ Keep <ul> and <li> as-is
                    if (el.tagName === 'UL' || el.tagName === 'LI') {
                        el.removeAttribute('color');
                        if (el.style) {
                            el.style.color = '';
                        }
                        return;
                    }
                    // Remove unwanted attributes
                    el.removeAttribute('color');

                    if (el.style) {
                        el.style.color = '';
                    }
                });

                // Replace selection with cleaned content
                const cleanedFragment = document.createDocumentFragment();
                cleanedFragment.append(...tempDiv.childNodes);
                range.deleteContents();
                range.insertNode(cleanedFragment);

                // Restore cursor position after cleanup
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }

        this.sunEditorInstance.onKeyDown = (event,core) =>{
           console.log("Send message",event,core);
           if(event.key.length === 1){ 
             this.checkForMentions(event)
           }

          if (event.key === "Enter" && event.shiftKey && !this.isEditorIsInFullScreen) { // make shift + enter behaviour same as Enter
             event.preventDefault();
             document.execCommand("insertParagraph");
             core.focus(); // ensure caret stays visible and active
            return;
          }
          if(event.key === "Enter" && !this.isEditorIsInFullScreen && !event.shiftKey && this.isEnterSendAllowed){
            event.preventDefault();
            this.editMessageEnabled?this.updateMessage(event):this.sendMessageOrReply(event);
            core.history.reset(0);
          }
        }

        if(this.commentDataToEdit != undefined && Object.prototype.hasOwnProperty.call(this.commentDataToEdit,'message')){
            this.replyContext = true;
            this.sunEditorInstance.setContents(this.commentDataToEdit.message);
        }else if(this.commentDataToEdit && !Object.prototype.hasOwnProperty.call(this.commentDataToEdit,'message')){
            this.replyContext = true;
            this.sunEditorInstance.setContents(this.commentDataToEdit);
        }

        console.log("INSIDE MOUNTED>>>>>>>>>>>>>>>>",this.commentDataToEdit);
    
     });
   },
   components:{
       'attach-file':AttachFile,
        "files-browser":fileBrowseModel
        // 'attach-file':cloneDeep(parent.document.body.component.attachments),
        // "files-browser":cloneDeep(parent.document.body.component.fileBrowser),
   },
   computed:{
        getButtonStyles(){
            if(this.buttonStyles && Object.keys(this.buttonStyles).length){
                return this.buttonStyles;
            }
            return {};
        },
        getFilesCountClass(){
            let screen = '';
            screen = this.isEditorIsInFullScreen ? 'main-editor-in-full-screen-mode' : '';
            if(this.attachedFilesArr.length ==1){
                return 'one-attachment '+screen;
            }else if(this.attachedFilesArr.length >=2){
                return 'two-attachment '+screen;
            }
           return ""+screen;
        },
        getWorkspacesList(){
            return this.chatBrowseWorkspaceList;
        },
        attachmentData(){
            return {selectedFilesFromAttachBrowse:this.selectedFilesFromAttachments}
        },
        filteredDropdown() {
           const searchTerm = this.keypressedForMention 
                ? this.keypressedForMention.substr(1).toLowerCase() 
                : null;
           if(this.usersFilterFunction){
                 return this.usersFilterFunction.filter((user) => {
                        const username = user.username ? user.username.toLowerCase() : '';
                        return username.includes(searchTerm);
                });
               // return this.usersFilterFunction;
            }
            const userMap = this.getUsersBasicInfoFromStore; // Your Vuex map
            let usersToFilter = [];

            if (this.channelData && Array.isArray(this.channelData.channel_members)) {
                usersToFilter = this.channelData.channel_members
                    .map(id => userMap[id])
                    .filter(user => user); 
            } else if (this.usersList && Array.isArray(this.usersList)) {
                usersToFilter = this.usersList;
            }

            if (!searchTerm || searchTerm.length === 0) {
                return usersToFilter;
            }

            return usersToFilter.filter((user) => {
                const username = user.username ? user.username.toLowerCase() : '';
                return username.includes(searchTerm);
            });
        },
      ...mapGetters("users", ["getLoggedInUserPrivilege","getUsersBasicInfoFromStore"]),
      ...mapGetters("registry",["getLinksBrowseListPlugins"]),
    },
   watch :{
        "$route.fullPath": function(newVal, oldVal){
            if (newVal != oldVal){
                this.sunEditorInstance.setContents('');
            }
        },
        commentText(newVal){
            this.$emit("postComment",newVal); 
        },

        'commentDataToEdit.message':function(newVal){
            if(newVal != undefined && newVal != null){
                this.commentText = newVal;
            }
        },
        attachmentContext(newVal){
            if(newVal != undefined && newVal != null){
                this.attachmentUniqueId = this.attachmentContext;
            }
        },
        emptyAttachmentsData(newVal){
            if(newVal){
                this.openAttachments = false;
                if(this.clearMainInputAreaText){
                    this.commentText = ""; 
                    this.showMentions = false;
                }
                this.selectedFilesFromAttachBrowse = null;
                this.attachedFilesArr = [];
                this.attachedFiles = [];
                this.emptyfiles = true;
            }
        },
        closeMentions(val){
            console.log(val);
            this.showMentions = false
        },
   },

   methods:{
    isBrowseEnabled(privilegeName){
         if(typeof privilegeName == 'boolean'){
             return privilegeName;
         }
        if(!privilegeName){
            return true;
        }
        return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,privilegeName)
    },
    setRichTextEditorContent(content){
        this.sunEditorInstance.setContents(content);
    },
    getPlainTextFromSunEditor(sunEditorInstance) {
      let html = "";
      if(!sunEditorInstance){
         html = this.sunEditorInstance.getContents();
      }else{
            html = sunEditorInstance.getContents();
      }
  
      html = html
            .replace(/<(script|style|img|video|audio|iframe|svg|canvas|object|embed|input|button|select|textarea|form)[^>]*>[\s\S]*?<\/\1>/gi, '')
            .replace(/<(img|video|audio|iframe|svg|canvas|input)[^>]*>/gi, '');
        
        // Handle lists - just convert to line breaks
        html = html
            .replace(/<\/li>/gi, '\n')
            .replace(/<\/(ul|ol)>/gi, '\n');
        
        // Handle table cells
        html = html
            .replace(/<\/(td|th)>/gi, ' ')
            .replace(/<\/tr>/gi, '\n');
        
        // Handle hr
        html = html.replace(/<hr[^>]*>/gi, '\n');
        
        // Convert block elements to line breaks
        html = html
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<\/(p|div|h[1-6]|blockquote|section|figure|figcaption|thead|tbody|table)>/gi, '\n');
        
        // Remove all remaining HTML tags
        html = html.replace(/<[^>]+>/g, '');
        
        // Decode HTML entities
        const entities = {
            '&nbsp;': ' ',
            '&amp;': '&',
            '&lt;': '<',
            '&gt;': '>',
            '&quot;': '"',
            '&#39;': "'",
            '&apos;': "'",
        };
        
        let text = html;
        Object.keys(entities).forEach(entity => {
            text = text.replace(new RegExp(entity, 'g'), entities[entity]);
        });
        
        // Decode numeric entities
        text = text.replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec));
        text = text.replace(/&#x([0-9a-f]+);/gi, (match, hex) => String.fromCharCode(parseInt(hex, 16)));
        
        // Clean up whitespace
        text = text
            .replace(/[ \t]+/g, ' ')
            .replace(/ *\n */g, '\n')
            .replace(/\n{3,}/g, '\n\n')
            .trim();
        
        return text;
    },
    getRichTextEditorAttachedFiles(){
        return this.attachedFilesArr;
    },
    getRichTextEditorAttachedFilesLength(){
        return this.attachedFilesArr.length;
    },
    isAttachedFileUploadedCompletely(){
        if(!this.attachedFilesArr.length) return true;
        if(parent.document.getElementsByClassName("upload-unInitialized") && parent.document.getElementsByClassName("upload-unInitialized").length){
            if (confirm(`Upload not initialized, do you want to continue?`)) {
                //do nothing
                this.emptyfiles = true;
            }else{
                return false;
            }
        }
        if(parent.document.getElementsByClassName("upload-in-progress") && parent.document.getElementsByClassName("upload-in-progress").length){
            if (confirm(`Upload is still in progress, wait until it's complete.`)) {
                return false;
            }else{
                this.emptyfiles = true;
                //do nothing
            }
        }
        return true;
    },
    clearAllTheContents(){
        this.attachedFilesArr = [];
        this.attachedFiles = [];
        this.commentText = "";
        this.emptyfiles = true;
        this.openAttachments = false;
        this.selectedFilesFromAttachments = null;
        this.sunEditorInstance.setContents('');
        this.sunEditorInstance.core.history.reset(0);
    },
    getRichTextEditorPlainText(sunEditorInstance){
        if (!sunEditorInstance || !sunEditorInstance.core) {
            sunEditorInstance = this.sunEditorInstance;
        }
        if(!sunEditorInstance.getText()) return "";
        return this.getPlainTextFromSunEditor();
    },
    getFinalCleanedContent(sunEditorInstance) {
        if (!sunEditorInstance || !sunEditorInstance.core) {
            sunEditorInstance = this.sunEditorInstance;
        }
        // 1. Access the raw inner HTML of the editable area
        const rawHtml = sunEditorInstance.core.context.element.wysiwyg.innerHTML;
        // 2. Replace any remaining literal newline characters (\n) with HTML <br> tags.
        // This is necessary because the browser inserted text (even within <p>) retains \n.
        let cleanedHtml = rawHtml.replace(/\n/g, '<br>');
        // 3. Optional: Remove any empty paragraph tags that might have been left behind
        cleanedHtml = cleanedHtml.replace(/<p><\/p>/gi, '').trim();
        return cleanedHtml;
    },
    placeCaretAtTheStartOfSunEditor(){
        const editorCore = this.sunEditorInstance.core;
        const editor = editorCore.context.element.wysiwyg; // the editable div

        // Create a range at start
        const range = document.createRange();
        range.setStart(editor, 0); // start of editor
        range.setEnd(editor, 0);

        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        // Focus the editor
        editor.focus();
    },
    openAtMentionDropdownWhenFullscreen() {

        const getCaretRect = () => {
            const sel = window.getSelection();
            if(!this.isRTL()){
                if (!sel.rangeCount || !this.sunEditorInstance.getText()) return { top: 77, bottom: 98, left: 17 };
            }else{
                if (!sel.rangeCount || !this.sunEditorInstance.getText()) return { top: 77, bottom: 98, right:17 };
            }    
            const range = sel.getRangeAt(0).cloneRange();

            // Create a temporary marker span at the caret
            const marker = document.createElement("span");
            marker.textContent = "\u200b"; // zero-width space
            range.insertNode(marker);
            range.selectNode(marker);

            const rect = marker.getBoundingClientRect();
            marker.remove();
            return rect;
        };

        this.$nextTick(() => {
            const rect = getCaretRect();
            if (!rect) return;
            const dropdownHeight = 230;
            const dropdownWidth = 300; // set your mention box width here
            const viewportHeight = window.innerHeight;
            const viewportWidth = window.innerWidth;
            const spaceAbove = rect.top;
            const spaceBelow = viewportHeight - rect.bottom;
            const spaceRight = viewportWidth - rect.left;
            let top;
            let left = rect.left;
            // Handle top & bottom positioning
            if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
              top = rect.top - dropdownHeight;
            } else {
              top = rect.bottom;
            }

            // Handle right edge merging (prevent overflow)
            if (spaceRight < dropdownWidth) {
               left = viewportWidth - dropdownWidth - 8; // 8px padding from right
                if (left < 0) left = 0; // in case dropdown wider than viewport
            }
            this.mentionDropdownPosition = {
                position: "absolute",
                'inset-inline-start': left + window.scrollX + "px",
                top: top + window.scrollY + "px",
                zIndex: 9999,
            };
          });
       },

       closeEditorFullScreen(){
          this.sunEditorInstance.core.context.element.toolbar.querySelector('button[data-command="fullScreen"]').click();
       },
       placeTheCursorAtTheEndSunEditor(core){
          if(this.replyContext){ // place the cursor/focus at the trailing character
                core.focus();
                const range = core.getRange();
                const selection = core.getSelection();
                const wysiwyg = core.context.element.wysiwyg;
                // find last node inside editor
                let lastNode = wysiwyg.lastChild;
                if (lastNode) {
                    // if it's an element with children, dig into its last text node
                    while (lastNode && lastNode.lastChild) {
                        lastNode = lastNode.lastChild;
                    }
                    range.setStart(lastNode, lastNode.textContent.length);
                    range.collapse(true);
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
                core.focus();
           }
       },
       scrollInsideTheSuneditorToTheEnd(core){
          const wysiwyg = core.context.element.wysiwyg;
          wysiwyg.scrollTop = wysiwyg.scrollHeight;
       },
       scrollSunEditorTotheCenter(core, reload){
             console.log(reload);
             let chatWindow;
            // if(this.$parent.isReplyThreadVisible){
            //     if(this.$parent.enableEditMessage && String(this.$parent.enableEditMessage).startsWith('reply_')){
            //         chatWindow = this.$parent.$refs.replyThreadWindow;
            //     }else{
            //         chatWindow = this.$parent.$refs.chatWindow;
            //     }
            // }else{
            //   chatWindow = this.$parent.$refs.chatWindow;
            // }
            chatWindow = this.$parent.$el.closest(this.richTextParentScrollContainer);
            console.log("SCROLL CONTAINER.......",chatWindow);
            const editorEl = core.context.element.wysiwyg;
            console.log("chatWindow && editorEl",chatWindow , editorEl);
             if(chatWindow && editorEl) {
                const chatRect = chatWindow.getBoundingClientRect();
                const editorRect = editorEl.getBoundingClientRect();
                const currentScroll = chatWindow.scrollTop;
                const diff =
                    (editorRect.top + editorRect.height / 2) -
                    (chatRect.top + chatRect.height / 2);

                chatWindow.scrollTo({
                    top: currentScroll + diff,
                    behavior: 'smooth'
                });
                this.placeTheCursorAtTheEndSunEditor(core);
                this.scrollInsideTheSuneditorToTheEnd(core);
             }else{
                this.placeTheCursorAtTheEndSunEditor(core);
             }
       },
       getLangaugeMapperForEditor(t) {
        return {
            toolbar: {
                undo: t('Undo'),
                redo: t('Redo'),
                font: t('Font'),
                fontSize: t('Font Size'),
                formatBlock: t('Format'),
                fontColor: t('Text Color'),
                hiliteColor: t('Highlight Color'),
                bold: t('Bold'),
                underline: t('Underline'),
                italic: t('Italic'),
                strike: t('Strike'),
                outdent: t('Outdent'),
                indent: t('Indent'),
                align: t('Align'),
                list: t('List'),
                table: t('Table'),
                horizontalRule: t('Horizontal Rule'),
                paragraphStyle: t('Paragraph Style'),
            },
            dialogBox: {
            // you can also localize dialog titles/tooltips here
            },
            // other sections: menu, color, etc. → add as needed
          };
        },

       replaceTrailingSlashesFromContent(textContent){
           if(!textContent) return textContent;
           //return String(textContent).replace(/(<br\s*\/?>\s*)+(?=<\/p>)/gi, '');
           if(textContent && String(textContent).trim() == '<p><br></p>'){
               return "";
           }
           return textContent;
       },
       toggleEditorToolbar(){
          if(this.isEditorToolbarOpen){
             this.sunEditorInstance.toolbar.hide();
             this.isEditorToolbarOpen = false;
          }else{
             this.sunEditorInstance.toolbar.show();
             this.isEditorToolbarOpen = true;
          }
          this.$nextTick(()=>{
              setTimeout(()=>{
                    this.scrollSunEditorTotheCenter(this.sunEditorInstance.core);
                    this.sunEditorInstance.core.focus();
              },200);
          });
       },
       toggleRichtextEditorToolbar(isEditorToolbarOpen){
          this.isEditorToolbarOpen = isEditorToolbarOpen;
          if(isEditorToolbarOpen){
             this.sunEditorInstance.toolbar.show();
             this.isEditorToolbarOpen = true;
          }else{
             this.sunEditorInstance.toolbar.hide();
             this.isEditorToolbarOpen = false;
          }
          this.$nextTick(()=>{
              setTimeout(()=>{
                    this.scrollSunEditorTotheCenter(this.sunEditorInstance.core);
                    this.sunEditorInstance.core.focus();
              },200);
          });
       },
       style(name){
        let style = {
            'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
            'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
        }
        return style
        },
       replaceWithUserIcon(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
       getUniqueId(){
        return Utils.getUUID();
       },
       resetImageUploader(){
           this.$refs.uploadFile.value = '';
       },
       getSelectedFileDetailsFromBrowse(){
        this.selectedFilesFromAttachments = this.$refs.uploadFile.files;
        this.browserType = "";
        this.openAttachments = true;
       },

       openPipOfAttachment(fileInfo){
        this.$emit("openPipOfSelectedFile",fileInfo)
       },
        closeModal(){
            this.attachedFiles = [];
            this.browserType = '';
            // this.openFileBrowse = false;
        },
        isButtonRequired(name){
            if(!this.buttonRequiredList) return false;
            if(this.buttonRequiredList && Array.isArray(this.buttonRequiredList) && this.buttonRequiredList.length === 0) return false;
            if(this.buttonRequiredList.indexOf(name) > -1) return true;
            return true;
        },
        attachedFilesList(attcahedFilesArray,alreadyAttachedFiles){
            this.attachedFilesArr = [];
            if(alreadyAttachedFiles != undefined && alreadyAttachedFiles.length){
                for(let j = 0; j< alreadyAttachedFiles.length; j++){
                    this.attachedFilesArr.push(alreadyAttachedFiles[j].file_uid);
                }
            }
            if(attcahedFilesArray != undefined && attcahedFilesArray.length){
                for(let i=0; i<attcahedFilesArray.length; i++){
                    this.attachedFilesArr.push(attcahedFilesArray[i].fileUID);
                }
            }
        },
        checkForMentions(e){
            let temp = /[ `!#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
            if(temp.test(e.key) || e.code == 'Space'){
                this.showMentions = false;
                this.keypressedForMention = '';
                return;
            }
            
            if(e.key == '@'){
                if(this.keypressedForMention.startsWith('@')){
                    this.showMentions = false;
                }else{
                    this.showMentions = true;
                    this.keypressedForMention = e.key;
                }
                    this.showMentions = true;

                if(this.showMentions){
                    this.openAtMentionDropdownWhenFullscreen();
                }
            }
            if(this.keypressedForMention.startsWith('@')){
                if(e.key != '@'){
                    this.keypressedForMention = this.keypressedForMention.concat(e.key);
                }
            }else{
                this.keypressedForMention = '';
                this.showMentions = false;
            }
        },
        getPosition(){
            return {"left":this.positionOfDropdown.left + 'px',"top":this.positionOfDropdown.top + 'px'}
        },
        detectBackspace(event){
            // let lastWord = this.commentText.split(" ");
            let lastWord = event.target.innerText.split(" ");
            console.log("[detectBackspace][lastWord]",lastWord);
            let mentionCharacterCheck = lastWord[lastWord.length - 1].startsWith('@');
            if(mentionCharacterCheck){
                this.keypressedForMention = lastWord[lastWord.length - 1];
            }else{
                this.keypressedForMention = '';
                this.showMentions = false;
            }
        },
        selectUserToBeMentioned(userData = {}){
            //let curPos = 0;
            const selection = this.sunEditorInstance.core.getSelection(); // get selection range
            /*
            if(this.$refs["commentArea"]){
                curPos = this.$refs["commentArea"].selectionStart;
            }else{
                curPos = this.$refs["replyMessageArea"].selectionStart;
            }*/
            const curPos = selection.focusOffset; // caret position
            const textNode = selection.focusNode; // node where typing happens
            let text_to_replace = userData.username + " ";
            /*
            if(this.$refs["commentArea"]){
                this.$refs["commentArea"].focus(); // Ensure the this.$refs["commentArea"] has focus
            }else if(this.$refs["replyMessageArea"]){
                this.$refs["replyMessageArea"].focus();
            }
            if(this.keypressedForMention.length == 1 && this.keypressedForMention == '@'){
                this.commentText = this.commentText.slice(0, curPos) + text_to_replace + this.commentText.slice(curPos);
            }else{
                this.commentText = this.commentText.slice(0, curPos - this.keypressedForMention.length) + '@'+text_to_replace + this.commentText.slice(curPos);
            }*/
            if (this.keypressedForMention.length === 1 && this.keypressedForMention === '@') {
                // Just replace '@' with '@JohnDoe'
                textNode.textContent =
                textNode.textContent.slice(0, curPos - 1) +
                '@' + text_to_replace +
                textNode.textContent.slice(curPos);
            } else {
                // Replace '@something' with '@JohnDoe'
                textNode.textContent =
                textNode.textContent.slice(0, curPos - this.keypressedForMention.length) +
                '@' + text_to_replace +
                textNode.textContent.slice(curPos);
            }

            const editor = this.sunEditorInstance;
            const range = editor.core.getRange();
            const wysiwyg = editor.core.context.element.wysiwyg;

            // find last node inside editor
            let lastNode = wysiwyg.lastChild;
            if (lastNode) {
                // dig into its last child if needed
                while (lastNode && lastNode.lastChild) {
                    lastNode = lastNode.lastChild;
                }

                // If lastNode is a text node → append a space
                if (lastNode.nodeType === Node.TEXT_NODE) {
                    lastNode.textContent += "\u00A0";
                } else {
                    // otherwise insert a new text node with a space
                    const spaceNode = document.createTextNode("\u00A0");
                    wysiwyg.appendChild(spaceNode);
                    lastNode = spaceNode;
                }

                // set caret after the space
                range.setStart(lastNode, lastNode.textContent.length);
                range.collapse(true);

                selection.removeAllRanges();
                selection.addRange(range);
            }

            // Ensure editor is focused
            editor.core.focus();


            this.keypressedForMention = '';
            this.showMentions = false;
        },
        sendMessageOrReply(e){
            if(!this.sunEditorInstance.getText() && !this.attachedFilesArr.length) return;
            if(e){
                this.selectElementsThroughKeys(e);
                if(this.stop == true){
                    this.stop = false
                    e.preventDefault();
                    return false;
                }
                if(e && e.shiftKey){
                    return;
                }
                if(e.code == 'ArrowUp' || e.code == 'ArrowDown'){
                    if(this.showMentions){
                        e.preventDefault();
                    }
                }
                if(e && e.key == "Enter"){
                    e.preventDefault();
                    if(parent.document.getElementsByClassName("upload-unInitialized") && parent.document.getElementsByClassName("upload-unInitialized").length){
                        if (confirm(`Upload not initialized, do you want to continue?`)) {
                            //do nothing
                            this.emptyfiles = true;
                        }else{
                            return false;
                        }
                    }
                    if(parent.document.getElementsByClassName("upload-in-progress") && parent.document.getElementsByClassName("upload-in-progress").length){
                        if (confirm(`Upload is still in progress, wait until it's complete.`)) {
                            return false;
                        }else{
                            this.emptyfiles = true;
                            //do nothing
                        }
                    }
                    if(this.showMentions){
                        return;
                    }
                    this.commentText = this.getFinalCleanedContent(this.sunEditorInstance)//this.sunEditorInstance.getContents();//this.commentText.replace(/^\s+|\s+$/g, '')
                    let plainMessage = this.getRichTextEditorPlainText()//this.sunEditorInstance.getText();
                    this.$emit("messageText",this.replaceTrailingSlashesFromContent(this.commentText),this.attachedFilesArr, plainMessage);
                    this.attachedFilesArr = [];
                    this.attachedFiles = [];
                    this.commentText = "";
                    this.emptyfiles = true;
                    this.openAttachments = false;
                    this.selectedFilesFromAttachments = null;
                    this.sunEditorInstance.setContents('');
                    this.sunEditorInstance.core.history.reset(0);
                    if(this.isEditorIsInFullScreen){
                       this.closeEditorFullScreen()
                    }
                }
            }else{
                if(parent.document.getElementsByClassName("upload-unInitialized") && parent.document.getElementsByClassName("upload-unInitialized").length){
                    if (confirm(`Upload not initialized, do you want to continue?`)) {
                        //do nothing
                    }else{
                        this.emptyfiles = true;
                        return false;
                    }
                }
                if(parent.document.getElementsByClassName("upload-in-progress") && parent.document.getElementsByClassName("upload-in-progress").length){
                    if (confirm(`Upload is still in progress, wait until it's complete.`)) {
                        this.emptyfiles = true;
                        return false;
                    }else{
                        //do nothing
                    }
                }
                this.commentText = this.getFinalCleanedContent(this.sunEditorInstance);//this.sunEditorInstance.getContents();//this.commentText.replace(/^\s+|\s+$/g, '')
                let plainMessage = this.getRichTextEditorPlainText();//this.sunEditorInstance.getText();
                this.$emit("messageText",this.replaceTrailingSlashesFromContent(this.commentText),this.attachedFilesArr, plainMessage);
                this.attachedFilesArr = [];
                this.attachedFiles = [];
                this.commentText = "";
                this.emptyfiles = true;
                this.openAttachments = false;
                this.selectedFilesFromAttachments = null;
                this.sunEditorInstance.setContents('');
                this.sunEditorInstance.core.history.reset(0);
                if(this.isEditorIsInFullScreen){
                     this.closeEditorFullScreen();
                }
            }
        },

        sendThumbsUpEmoji(emoji){
            this.sunEditorInstance.insertHTML(emoji);
            // this.sunEditorInstance.insertHTML('&nbsp;');
            this.showEmojis = false;
        },

        hideEmojis(){
            this.showEmojis = false
        },

        hideTaskTicketsMenu(){
            this.isTasksAndTicketsDropdownShown = false;
        },
        
        handleFilesBrowse(selectedFiles){
            if(this.isNewPluginRegistrationApproach){  // new registration approach
                this.$emit("insertURLOfSelectedItems",selectedFiles);
                return;
            }
            if(this.chatBrowseWorkspaceList.filter(e =>this.tasksTicketsBrowseList.includes(e)).length){
                for(let i= 0 ;i<selectedFiles.length;i++){
                    let urlType = "";
                    if(selectedFiles[i].task_type == 'Task'){
                        urlType = "/explorer/projects/" + selectedFiles[i].project_id + "/tasks/";
                    }else if(selectedFiles[i].task_type == "Issue"){
                        urlType = "/explorer/projects/" + selectedFiles[i].project_id + "/issues/";
                    }else if(selectedFiles[i].task_type == "Ticket"){
                        urlType = "/explorer/ticket/";
                    }
                    let appendUrl = window.location.protocol + '//' + window.location.host + urlType + selectedFiles[i].task_tag;
                    let curPos = 0;
                    if(this.$refs["commentArea"]){
                        curPos = this.$refs["commentArea"].selectionStart;
                    }else{
                        curPos = this.$refs["replyMessageArea"].selectionStart;
                    }
                    this.commentText = this.commentText.slice(0, curPos) + " " +appendUrl + " " + this.commentText.slice(curPos);
                    this.sunEditorInstance.insertHTML(` ${appendUrl} `);
                    this.sunEditorInstance.insertHTML('&nbsp;');
                    if(this.$refs["commentArea"]){
                        this.$refs.commentArea.focus();
                    }else if(this.$refs["replyMessageArea"]){
                        this.$refs.replyMessageArea.focus();
                    }
                }
            }else if(this.chatBrowseWorkspaceList.filter(e =>['confluence'].includes(e)).length){
                for(let i= 0 ;i<selectedFiles.length;i++){
                    let appendUrl = selectedFiles[i].link;
                    let curPos = 0;
                    if(this.$refs["commentArea"]){
                        curPos = this.$refs["commentArea"].selectionStart;
                    }else{
                        curPos = this.$refs["replyMessageArea"].selectionStart;
                    }
                    this.commentText = this.commentText.slice(0, curPos) + " " +appendUrl + " " + this.commentText.slice(curPos);
                    this.sunEditorInstance.insertHTML(` ${appendUrl} `);
                    this.sunEditorInstance.insertHTML('&nbsp;');
                    if(this.$refs["commentArea"]){
                        this.$refs.commentArea.focus();
                    }else if(this.$refs["replyMessageArea"]){
                        this.$refs.replyMessageArea.focus();
                    }
                }
            }
            else{
                this.attachedFiles = selectedFiles;
                this.openAttachments = true;
            }
            this.browserType = '';
        },

        selectElementsThroughKeys: function(event) {
            console.log("selectElementsThroughKeys selectElementsThroughKeys",event.keyCode);
            switch (event.keyCode) {
                case 38:
                if (this.focus === null) {
                    this.focus = 0;
                } else if (this.focus > 0) {
                    this.focus--;
                    event.preventDefault();
                }
                this.fixScrolling();
                break;
                case 40:
                if (this.focus === null) {
                    this.focus = 0;
                } else if (this.focus < this.usersList.length - 1) {
                    this.focus++;
                    event.preventDefault();
                }
                this.fixScrolling();
                break;
                case 13:
                    if(this.showMentions){
                        this.stop = true;
                        if(!this.focus && !this.filteredDropdown[this.focus]){
                            this.showMentions = false;
                            this.keypressedForMention = '';
                            this.showMentions = false;
                            this.stop = false;
                            event.preventDefault();
                        }else{
                            this.selectUserToBeMentioned(this.filteredDropdown[this.focus]);
                            event.preventDefault();
                        }
                    }
                break;
            }
            
        },
        openFileBrowseOnClick(browser){
           if(this.isNewPluginRegistrationApproach){  // new registration approach
             this.$emit("selectedBrowseWindowType",browser);
             return;
           }
            this.browserType = "fusion";
            if(browser == 'fusion'){
                this.chatBrowseWorkspaceList = [Constants.WORKSPACE_CATALOG,Constants.WORKSPACE_BINS];
            }else if(browser == 'tickets'){
                this.chatBrowseWorkspaceList = [Constants.WORKSPACE_TICKETS];
            }else if(browser == 'tasks'){
                this.chatBrowseWorkspaceList = [Constants.WORKSPACE_TASKS];
            }else if(browser == 'issues'){
                this.chatBrowseWorkspaceList = [Constants.WORKSPACE_ISSUES];
            }else if(browser == 'confluence'){
                this.chatBrowseWorkspaceList = ['confluence'];
            }
        },
        fixScrolling(){
            const liH = this.$refs.test[this.focus].clientHeight;
            this.$refs.scrollContainer.scrollTop = liH * this.focus;
        },
        updateMessage(e){
            if(e){
                this.selectElementsThroughKeys(e);
                if(this.stop == true){
                    this.stop = false
                    e.preventDefault();
                    return false;
                }
                if(e && e.shiftKey){
                    return;
                }
                if(e.code == 'ArrowUp' || e.code == 'ArrowDown'){
                    if(this.showMentions){
                        e.preventDefault();
                    }
                }
                if(e && e.key == "Enter"){
                    e.preventDefault();
                    if(this.showMentions){
                        return;
                    }
                    this.commentText = this.getFinalCleanedContent(this.sunEditorInstance);//this.sunEditorInstance.getContents(); //this.commentText.replace(/^\s+|\s+$/g, '')
                    let plainMessage = this.getRichTextEditorPlainText();//this.sunEditorInstance.getText();
                    this.$emit("editMessageText",this.replaceTrailingSlashesFromContent(this.commentText),this.commentDataToEdit._id,plainMessage);
                    this.commentText = "";
                    this.emptyfiles = true;
                    this.selectedFilesFromAttachments = null;
                    this.sunEditorInstance.core.history.reset(0);
                    if(this.isEditorIsInFullScreen){
                       this.closeEditorFullScreen()
                    }
                }
            }else{
                this.commentText = this.getFinalCleanedContent(this.sunEditorInstance);//this.sunEditorInstance.getContents();//this.commentText.replace(/^\s+|\s+$/g, '')
                let plainMessage = this.getRichTextEditorPlainText();//this.sunEditorInstance.getText();
                this.$emit("editMessageText",this.replaceTrailingSlashesFromContent(this.commentText),this.commentDataToEdit._id,plainMessage);
                this.commentText = "";
                this.emptyfiles = true;
                this.selectedFilesFromAttachments = null;
                this.sunEditorInstance.core.history.reset(0);
                if(this.isEditorIsInFullScreen){
                     this.closeEditorFullScreen()
                }
            }
        },
        cancelUpdateMessage(){
            this.$emit("cancelEditMessageText");
        },
        
        isEnabled(priv){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv)
        },

        textAreaHeightSet(){
            if(this.commentText.split('\n').length > 3){
                return 'min-height: 140px;'
            }else{
                return 'min-height: 90px;'
            }
        },
        ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserInfo"]),

    },

    created(){
        if(this.commentDataToEdit != undefined && this.commentDataToEdit != undefined){
            this.commentText = this.commentDataToEdit.message;
        }
        this.attachmentUniqueId = this.attachmentContext;
        if(this.isFileAttachmentRequired != null){
            this.isFileAttachmentReqrd = this.isFileAttachmentRequired;
        }
        if(this.isEmojiRequired != null){
            this.isEmojiReqrd = this.isEmojiRequired;
        }
        if(this.isTaskTicketsBrowseRequired != null){
            this.isTaskTicketsBrowseReqrd = this.isTaskTicketsBrowseRequired;
        }
        if(this.isSendAndUpdateBtnRequired != null){
            this.isSendAndUpdateBtnReqrd = this.isSendAndUpdateBtnRequired;
        }
        if(this.isToggleToolbarBtnRequired != null){
            this.isToggleToolbarBtnReqrd = this.isToggleToolbarBtnRequired;
        }
        if(this.enterKeyPressSendAllowed != null){
            this.isEnterSendAllowed = this.enterKeyPressSendAllowed;
        }
        


    },
}
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $panel-heading-font-size:18px;
    $secondary-border-color: 1px solid #2b2b2b;


.reply-threadinput-field-height-check{
    max-height: 100% !important;
    // z-index: 999999999999;
}

.emojies-display{
    position: absolute;
    display: flex;
    border: $border-color;
    padding: 6px;
    top: -81px;
    inset-inline-start: 15px;
    background: #1f2327;
    padding: 6px;
    border-radius: 4px;
    width: 215px;
    justify-content: center;
    flex-wrap: wrap;
    z-index:9;
    span{
        padding: 5px 7px;
        border-radius: 4px;
        font-size:20px;
    }
}

.emojies-display span:hover{
    background: #fdfeff54;
}


.focusElement{
    background: #333;
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
}

.user-name{
    margin-inline-end: 10px;
    position: relative;
    bottom: 7px;
}

.icon-background-on-hover:hover{
  background: #fdfeff54 !important;
}

.icon-background-on-hover{
  background: #d1d2d31a;
  padding: 4px;
  height: 28px;
  width: 28px;
  border-radius: 4px;
  margin-inline-end:5px;
}

.text-area-with-border{
    max-height:200px;
    padding: 4px; 
}
.remove-border{
    max-height:200px;
    min-height: 80px;
    padding: 4px; 
    border: none !important;
    background:transparent;
} 
.remove-border:focus{
    outline: none !important;
    box-shadow: none;
}
.common-input-field{
    display: inline-block;
    width: 98%;
    justify-content: space-between;
    display: inline-block;
    padding: 5px;
    border-radius: 4px;
    background: $primary-background !important;
    border: $secondary-border-color !important;
    max-height:70%;
    // overflow: auto;
    position: relative;
    label{
        width: 30%;
        color: $dull-text-color;
        word-break: break-word;
    }
    input{
        flex:1;
    }
}

.input-fields,.mx-datepicker, textarea{
    border-radius: 3px !important;
    border: $border-color !important;
    height: 38px;
    background: $primary-background;
}

textarea:focus{
  outline: none;
  bottom: 0px;
  inset-inline-start: 0px;
  --saf-0: rgba(var(--sk_highlight,18,100,163),1);
  box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
  border-radius: 4px;
  border-color: transparent;
  -webkit-appearance: none;
}

.button-styles{
  height: 30px;
  width: auto;
  font-size: 14px;
  svg{
      position: relative;
      bottom: 3px;
  }
}

.mentions-wrapper{
    position: relative;
    border: $border-color;
    background: $secondary-background-color;
    max-height: 200px;
    min-width:200px;
    overflow: auto;
    z-index: 9;
    border-radius: 5px;
    .mentions-option{
        text-align: start;
        padding: 5px;
        display:flex;
    }
    .mentions-option:hover{
        background: #333;
    }
}

#DAM-chat-insert_pam{
    .dropdown-menu{
        position:absolute;
        top:-8px !important;
        inset-inline-start:10px !important;
    }
}

.sun-editor{
    width: 100% !important;
    text-align: start !important;
}

.chat-main-wrapper-div.main-editor-in-full-screen-mode > .common-input-field.input-field-height-check:first-child{
     max-height: unset !important;
    position: fixed;
    inset-inline-start: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: #15181B !important;
    max-height: unset !important;
    z-index: 999 !important;
}

.chat-main-wrapper-div.main-editor-in-full-screen-mode > .main-chat-area-zoom-screen{
    z-index: 99999 !important;
}

 .main-editor-in-full-screen-mode .replay-comment-btn{
    display: none !important;
  }


  :v-deep{
      .sun-editor{
         width: 100% !important;
         text-align: start !important;
         background-color: transparent !important;
      }
      .se-wrapper-inner.se-wrapper-wysiwyg.sun-editor-editable.editor-in-full-screen-mode:focus{
         border: none !important;   
      }

      .progressbar-wrapper{
         min-height: 102px !important;
      }

      .main-editor-in-full-screen-mode .main-comment-btn{
          display: none !important;
      }

      .main-editor-in-full-screen-mode .replay-comment-btn{
         display: none !important;
      }

     .sun-editor .se-container{
         background: #1a1e21 !important;
      }

      .sun-editor-editable pre{
           background-color: transparent !important;
           color: #eee !important;
           border: none !important;
       }

       .main-editor-in-full-screen-mode .rich-text-editor-save-and-cancel{
          display: none !important;
       }

      .main-editor-in-full-screen-mode .rich-texteditor-main-tools-wrapper .descriptionSaveUnsaveBtns{
         display: none !important;
      }

      .main-editor-in-full-screen-mode .all-configured-buttons{
         display: none !important;
      }

      .main-editor-in-full-screen-mode .configure-buttons-wrapper-within-a-slot{
          display: none !important;
      }
      
  }

    .main-editor-in-full-screen-mode .configure-buttons-wrapper-within-a-slot{
        display: none !important;
    }

    .main-editor-in-full-screen-mode .all-configured-buttons{
        display: none !important;
    }

    .main-editor-in-full-screen-mode .rich-texteditor-main-tools-wrapper .descriptionSaveUnsaveBtns{
        display: none !important;
    }

   .main-chat-area-zoom-screen .rich-text-editor-save-and-cancel{
        display: none !important;
    }

  .mentions-wrapper:empty {
      display: none;
  }

  .toggle-editor-icon{
      
  }

  .task-tickets-browse{
    position: absolute;
    display: flex;
    border: 1px solid #4a4a4a;
    top: -90px;
    inset-inline-start: 15px;
    background: #1f2327;
    padding: 6px;
    border-radius: 4px;
    width: 215px;
    justify-content: center;
    flex-wrap: wrap;
    z-index: 9;
    .dropdown-item{
        color: $text-color;
    }
    .dropdown-item:hover{
        color: $text-color !important;
        background: $bg-color-on-hover !important;
    }
  }

  #DAM-chat-insert_pam{
     position: relative;
  }

  .sun-editor{
    background-color: transparent !important;
  }

</style>